import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, XIcon } from 'lucide-react';
const names = ['Sanne V.', 'Thijs B.', 'Lotte J.', 'Daan M.', 'Femke K.', 'Bram de W.', 'Anouk S.', 'Jeroen D.', 'Eva H.', 'Ruben P.', 'Lisa van D.', 'Niels B.', 'Fleur M.', 'Sem K.', 'Iris de J.', 'Lars V.', 'Noor A.', 'Tim van L.', 'Marieke P.', 'Joost R.', 'Esther W.', 'Bas T.', 'Sophie de G.', 'Koen H.', 'Lieke S.'];
const cities = ['Amsterdam', 'Rotterdam', 'Utrecht', 'Den Haag', 'Eindhoven', 'Groningen', 'Tilburg', 'Almere', 'Breda', 'Nijmegen', 'Haarlem', 'Arnhem', 'Zwolle', 'Maastricht', 'Leiden', 'Amersfoort', 'Apeldoorn', '\'s-Hertogenbosch', 'Enschede', 'Delft', 'Alkmaar', 'Leeuwarden', 'Dordrecht'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-387" data-mp="1f0n4ry3i46tz">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-[60] max-w-[300px] md:bottom-6" role="status" aria-live="polite" data-id="element-388" data-mp="1a1k8b21l78xm">
          <div className="bg-slate-900/95 backdrop-blur-md rounded-2xl shadow-2xl shadow-black/50 border border-white/10 p-3.5 flex items-start gap-3" data-id="element-389" data-mp="1r1whexxg7e5o">
            <div className="w-9 h-9 bg-emerald-500/15 rounded-full flex items-center justify-center shrink-0" data-id="element-390" data-mp="20shlh0vw5avz">
              <ShoppingBag size={17} className="text-emerald-400" aria-hidden="true" data-id="element-391" data-mp="24tjoztwuc93r" />
            </div>
            <div className="min-w-0" data-id="element-392" data-mp="29so0ir78mix9">
              <p className="text-sm font-semibold text-white leading-tight" data-id="element-393" data-mp="29tp98p0s6tbt">
                {data.name} uit {data.city}
              </p>
              <p className="text-xs text-slate-300 mt-0.5" data-id="element-394" data-mp="ff4vkwavny1x">
                kocht zojuist{' '}
                <span className="font-semibold text-sky-400" data-id="element-395" data-mp="ke810hurs6af">
                  Functionele Training 365
                </span>
              </p>
              <p className="text-[11px] text-slate-500 mt-1" data-id="element-396" data-mp="cvi8s343aryc">
                {data.minutes} minuten geleden
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-slate-500 hover:text-white transition-colors duration-150 ml-auto shrink-0 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" aria-label="Melding sluiten" data-id="element-397" data-mp="825izpnocf40">
              <XIcon size={14} aria-hidden="true" data-id="element-398" data-mp="vsjclklwqm0p" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}